// @ts-nocheck
import React, {useState} from 'react';
import {View, FlatList, LogBox, StyleSheet} from 'react-native';
import {ActivityIndicator, Menu, Card} from 'react-native-paper';
import Text from '../../../components/Text';
import {useSelector} from 'react-redux';
import {colorSwatches, styles as gobalStyles} from '../../../styles';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../service/flashMessage';
import MySearchbar from '../../../components/MySearchbar';
import NavbarWithAction from '../../../components/NavbarWithAction';
import {useFocusEffect} from '@react-navigation/native';
import {
  deleteViolationById,
  fetchViolationsByUnit,
} from '../../../api/violation';
import {RootStore} from '../../../redux/store';
import {permissionToBool} from '../../../utils';
import IconButton from '../../../components/IconButton';
import Container from '../../../components/Container';
import Content from '../../../navigation/Content';
import {showKeyboardAwareAlert} from '../../../utils/keyboard';

const Violations = ({navigation}) => {
  const [violations, setViolations] = useState([]);
  const [violationsHolder, setViolationsHolder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const defaultUnit = useSelector(
    (state: RootStore) => state.units.unitLinks,
  ).find(link => link.isDefault === true);
  const [searchTerm, setSearchTerm] = useState('');
  const [isNavbarShown, setIsNavbarShown] = useState(true);

  const fetchViolations = async unit => {
    setIsLoading(true);
    try {
      const response = await fetchViolationsByUnit(unit);
      setViolations(response);
      setViolationsHolder(response);
    } catch (error) {
      showErrorMessage(error.toString());
    }
    setIsLoading(false);
  };

  const ignoreListsWarnings = () => {
    LogBox.ignoreLogs(['VirtualizedLists should never be nested']);
  };

  useFocusEffect(
    React.useCallback(() => {
      ignoreListsWarnings();
      if (defaultUnit?.unit?.id) {
        fetchViolations(defaultUnit?.unit?.id);
      } else {
        setViolations([]);
        setViolationsHolder([]);
        setIsLoading(false);
      }
    }, [defaultUnit]),
  );

  const showDeleteViolationPrompt = violationId => {
    showKeyboardAwareAlert(
      '',
      'Do you really want to delete violation ?',
      [
        {
          text: 'NO',
          onPress: () => console.log('Cancel Pressed'),
          style: 'cancel',
        },
        {
          text: 'YES',
          onPress: () => deleteViolation(violationId),
        },
      ],
      {
        cancelable: true,
      },
    );
  };

  const deleteViolation = async violationId => {
    try {
      await deleteViolationById(violationId);
      showSuccessMessage('Violation deleted successfully');
    } catch (error) {
      showErrorMessage(error.message);
    }
    if (!defaultUnit?.unit?.id) {
      return;
    }
    await fetchViolations(defaultUnit?.unit?.id);
  };

  const searchHandler = searchString => {
    setSearchTerm(searchString);
    const newPets = violationsHolder.filter(pet => {
      const clientData = `${pet.petName.toUpperCase()}`;
      const searchTermData = searchString.toUpperCase();
      return clientData.indexOf(searchTermData) > -1;
    });
    setViolations(newPets);
  };

  return (
    <Container>
      <Content>
        {isNavbarShown ? (
          <NavbarWithAction
            navigation={navigation}
            hasBackArrow
            hasSearch={violations.length > 0}
            title="Violations"
            showCurrentUnit
            onClickSearch={() => setIsNavbarShown(false)}
            hasAdd={permissionToBool(
              defaultUnit?.violationsPermission?.charAt(3),
            )}
            onClickAdd={() =>
              navigation.navigate('Add Violation', {violation: null})
            }
            fullScreen
          />
        ) : (
          <MySearchbar
            placeholder="Search  name"
            value={searchTerm}
            setValue={val => searchHandler(val)}
            resetSearch={() => {
              setIsNavbarShown(true);
              setSearchTerm('');
              setViolations(violationsHolder);
            }}
          />
        )}
        {isLoading ? (
          <ActivityIndicator
            animating={true}
            color={colorSwatches.primary.color}
            style={styles.loadingIndicator}
          />
        ) : (
          <>
            <FlatList
              data={violations}
              style={styles.flatList}
              ListFooterComponent={<View style={styles.footerComponent} />}
              ListEmptyComponent={<Text>No violations found</Text>}
              renderItem={({item}) => (
                <ViolationsListItem
                  violation={item}
                  onSelectDelete={() => showDeleteViolationPrompt(item.id)}
                  itemClickHandler={() =>
                    navigation.navigate('Violation Detail', {
                      violationId: item.id,
                    })
                  }
                  onSelectEdit={() =>
                    navigation.navigate('Edit Violation', {violation: item})
                  }
                />
              )}
            />
          </>
        )}
      </Content>
    </Container>
  );
};

const ViolationsListItem = ({
  violation,
  onSelectEdit,
  onSelectDelete,
  itemClickHandler,
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const unitLink = useSelector(
    (state: RootStore) => state?.units?.unitLinks,
  ).filter(link => link.isDefault === true)[0];
  
  return (
    <Card style={styles.card} onPress={() => itemClickHandler()}>
      <View style={styles.cardContent}>
        <View style={styles.cardTextContainer}>
          <View style={styles.cardTextRow}>
            <Text style={styles.cardTitle}>
              {violation.violationCategory
                ? violation.violationCategory
                : 'Category not provided'}
            </Text>
          </View>
          <Text>
            {violation.specificViolation
              ? violation.specificViolation
              : 'Violation not provided'}
          </Text>
          <View style={styles.cardTextRow}>
            <Text>
              {violation.severityOfViolation
                ? violation.severityOfViolation
                : 'Severity not provided'}
            </Text>
          </View>
        </View>
        {(permissionToBool(unitLink?.violationsPermission?.charAt(1)) ||
          permissionToBool(unitLink?.violationsPermission?.charAt(4))) && (
          <View style={styles.menuContainer}>
            <Menu
              visible={menuVisible}
              onDismiss={() => setMenuVisible(false)}
              anchor={
                <IconButton
                  icon="ellipsis-vertical"
                  iconColor={'#718096'}
                  size={24}
                  onPress={() => setMenuVisible(true)}
                />
              }>
              {permissionToBool(unitLink?.violationsPermission?.charAt(1)) && (
                <Menu.Item
                  onPress={() => {
                    setMenuVisible(false);
                    onSelectEdit();
                  }}
                  title="Edit"
                />
              )}
              {permissionToBool(unitLink?.violationsPermission?.charAt(4)) && (
                <Menu.Item
                  onPress={() => {
                    setMenuVisible(false);
                    onSelectDelete();
                  }}
                  title="Delete"
                />
              )}
            </Menu>
          </View>
        )}
      </View>
    </Card>
  );
};

const styles = StyleSheet.create({
  loadingIndicator: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  flatList: {
    marginVertical: 12,
    marginHorizontal: 8,
    flex: 1,
  },
  footerComponent: {
    height: 32,
  },
  card: {
    borderRadius: 8,
    marginVertical: 8,
  },
  cardContent: {
    flexDirection: 'row',
    padding: 8,
    justifyContent: 'space-between',
  },
  cardTextContainer: {
    flex: 1,
    marginLeft: 8,
    justifyContent: 'space-around',
  },
  cardTextRow: {
    flexDirection: 'row',
    marginTop: 8,
  },
  cardTitle: {
    fontSize: 18,
  },
  menuContainer: {
    marginTop: 12,
    marginRight: 16,
  },
});

export default Violations;
